import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { ControlsBlock, ControlsRow } from 'components/Controls';
import InstituteCard from 'components/cards/InstituteCard';
import MultirowSlideSection from 'components/MultirowSlideSection';
import ButtonFilter from 'components/ButtonFilter';

import CommonPropTypes from 'utils/propTypes/common';

const controlHash = [
	{
		title: 'Театры',
		type: 'theater',
		markupAttributeValue: 'theater'
	},
	{
		title: 'Музеи',
		type: 'museum',
		markupAttributeValue: 'museum'
	},
	{
		title: 'Библиотеки',
		type: 'library',
		markupAttributeValue: 'biblio'
	},
	{
		title: 'Концертные площадки',
		type: 'concertVenue',
		markupAttributeValue: 'hall'
	},
	{
		title: 'Все площадки',
		type: 'all',
		icon: 'dots',
		markupAttributeValue: 'catalog'
	}
];

const StreamingPlatforms = ({ streamingPlatforms }) => {
	const [selectedType, setSelectedType] = useState('all');

	const onTypeSelect = useCallback((type) => {
		setSelectedType(type);
	}, []);

	const renderControls = useCallback(
		() => (
			<ControlsRow>
				{_(controlHash).map((control) => (
					<ControlsBlock key={control.type}>
						<ButtonFilter
							text={control.title}
							icon={control.icon && 'dots'}
							name={control.type}
							value={control.type}
							active={control.type === selectedType}
							onClick={onTypeSelect}
							data-streaming-platforms={control.markupAttributeValue}
						/>
					</ControlsBlock>
				))}
			</ControlsRow>
		),
		[selectedType]
	);

	return (
		<MultirowSlideSection
			title="Самые активные площадки трансляций"
			renderControls={renderControls}
			items={streamingPlatforms[selectedType]}
			moreControl={{
				title: 'Все площадки',
				url: '/streaming-platforms/[[...pathParams]]',
				as: '/streaming-platforms'
			}}
			CardComponent={InstituteCard}
			gridSize={2}
			direction="columns"
			markupBlocks={{ cards: { 'data-streaming-platforms': 'card' } }}
		/>
	);
};

StreamingPlatforms.propTypes = {
	streamingPlatforms: PropTypes.objectOf(CommonPropTypes.entities).isRequired
};

export default StreamingPlatforms;
